<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return { routerAlive: true };
  },
  created() {},
  watch: {},
  methods: {
    reload() {
      this.routerAlive = false;
      this.$nextTick(function() {
        this.routerAlive = true;
      });
    },
  },
};
</script>
<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
}

body {
  font-size: 14px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
}

/* Message 必须始终显示在参数设置、密码确认和倒计时等业务弹层之上。 */
.el-message {
  z-index: 10001 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
